import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Button,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../components/ui";

import RolesSettings from "./settings/RolesSettings";
import PipelineSettings from "./settings/PipelineSettings";
import TagsSettings from "./settings/TagsSettings";
import ChannelsSettings from "./settings/ChannelsSettings";
import MailboxSettings from "./settings/MailboxSettings";
import WorkflowSettings from "./settings/WorkflowSettings";
import LeadStagesSettings from "./settings/LeadStagesSettings";
import ActivityTemplatesSettings from "./settings/ActivityTemplatesSettings";
import CrmRolesSettings from "./settings/CrmRolesSettings";
import CrmUserRolesSettings from "./settings/CrmUserRolesSettings";
import CrmRoleMailboxesSettings from "./settings/CrmRoleMailboxesSettings";

export default function CrmSettingsPage() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("roles");

  return (
    <div className="p-4 md:p-6 max-w-[1400px] mx-auto space-y-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">
            CRM Settings
          </h1>
          <p className="text-sm text-muted-foreground">
            Administration for roles, pipeline, tags, channels, mailbox access and workflows.
          </p>
        </div>

        <Button variant="outline" onClick={() => navigate("/crm")}>
          Back to CRM
        </Button>
      </div>

      <Card>
        <CardHeader className="pb-3">
          <CardTitle>Administration</CardTitle>
          <CardDescription>
            Configure shared CRM structures and permissions.
          </CardDescription>
        </CardHeader>

        <CardContent>
          <Tabs value={tab} onValueChange={setTab} className="w-full">
            <TabsList className="flex flex-wrap gap-2 h-auto">
              <TabsTrigger value="roles">Roles</TabsTrigger>
              <TabsTrigger value="pipeline">Pipeline</TabsTrigger>
              <TabsTrigger value="tags">Tags</TabsTrigger>
              <TabsTrigger value="channels">Channels</TabsTrigger>
              <TabsTrigger value="mailbox">Mailbox</TabsTrigger>
              <TabsTrigger value="workflow">Workflow</TabsTrigger>
              <TabsTrigger value="lead-stages">Lead Stages</TabsTrigger>
              <TabsTrigger value="activity-templates">Activity Templates</TabsTrigger>
              <TabsTrigger value="crm-roles">CRM Roles</TabsTrigger>
              <TabsTrigger value="crm-user-roles">CRM User Roles</TabsTrigger>
              <TabsTrigger value="crm-role-mailboxes">CRM Role Mailboxes</TabsTrigger>
            </TabsList>

            <TabsContent value="roles" className="pt-4">
              <RolesSettings />
            </TabsContent>

            <TabsContent value="pipeline" className="pt-4">
              <PipelineSettings />
            </TabsContent>

            <TabsContent value="tags" className="pt-4">
              <TagsSettings />
            </TabsContent>

            <TabsContent value="channels" className="pt-4">
              <ChannelsSettings />
            </TabsContent>

            <TabsContent value="mailbox" className="pt-4">
              <MailboxSettings />
            </TabsContent>

            <TabsContent value="workflow" className="pt-4">
              <WorkflowSettings />
            </TabsContent>

            <TabsContent value="lead-stages">
                <LeadStagesSettings />
            </TabsContent>

            <TabsContent value="activity-templates">
                <ActivityTemplatesSettings />
            </TabsContent>

            <TabsContent value="crm-roles" className="pt-4">
                <CrmRolesSettings />
            </TabsContent>

            <TabsContent value="crm-user-roles" className="pt-4">
                <CrmUserRolesSettings />
            </TabsContent>

            <TabsContent value="crm-role-mailboxes" className="pt-4">
                <CrmRoleMailboxesSettings />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}